export default __webpack_public_path__ + "30d0e0016258b2040b30738d79a25872.png";